import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { FiPhoneCall, FiMail } from 'react-icons/fi';
import './Footer.css';
import Logo from '../../Assets/logo.png'; 

const Footer = () => {
  return (
    <footer className="footer-section">
      <Container>
        <Row className="gy-4 pb-5">
          {/* Brand Info - Left Aligned */}
          <Col lg={5} md={12} className="text-start">
            <div className="footer-brand">
              <img src={Logo} alt="Janta Roadways" className="footer-logo mb-4" />
              <h5 className="fw-bold mb-3">Janta Roadways Pvt. Ltd.</h5>
              <p className="footer-text mb-4">
                Flagship company of the Janta Group, delivering reliable and compliant 
                automobile logistics solutions across India since 1982.
              </p>
              <div className="contact-info">
                <div className="contact-item mb-2 d-flex align-items-center">
                  <FiPhoneCall className="contact-icon me-2" />
                  <span>Call : +91 XXXXX XXXXX</span>
                </div>
                <div className="contact-item d-flex align-items-center">
                  <FiMail className="contact-icon me-2" />
                  <span>info@jantaroadways.com</span>
                </div>
              </div>
            </div>
          </Col>

          {/* Quick Links - Left Aligned */}
          <Col lg={2} md={6} sm={6} className="text-start">
            <h5 className="footer-heading mb-4">Quick Links</h5>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#network">Our Network</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </Col>

          {/* Services - Left Aligned */}
          <Col lg={3} md={6} sm={6} className="text-start">
            <h5 className="footer-heading mb-4">Services</h5>
            <ul className="footer-links">
              <li><a href="#auto">Automobile Logistics</a></li>
              <li><a href="#chassis">Chassis Transport</a></li>
              <li><a href="#odc">ODC & Heavy Cargo</a></li>
              <li><a href="#style">Style Guide</a></li>
              <li><a href="#mining">Mining & Surface Transport</a></li>
            </ul>
          </Col>

          {/* Social Community - Bottom Right Corner */}
          <Col lg={2} md={12} className="d-flex flex-column justify-content-end align-items-lg-end align-items-start mt-4 mt-lg-0">
            <div className="social-wrapper text-lg-end text-start">
              <h6 className="social-label mb-3">Social Community</h6>
              <div className="social-icons d-flex gap-2 justify-content-lg-end justify-content-start">
                <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-link">
                  <FaFacebookF />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="social-link">
                  <FaLinkedinIn />
                </a>
              </div>
            </div>
          </Col>
        </Row>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <Row className="align-items-center py-4 border-top">
            <Col md={4} className="text-md-start text-center mb-2 mb-md-0">
              <p className="mb-0">Copyright © 2026 - All rights Reserved</p>
            </Col>
            <Col md={4} className="text-center mb-2 mb-md-0">
              <p className="mb-0">Designed by Ascent Brandworks</p>
            </Col>
            <Col md={4} className="text-md-end text-center">
              <div className="bottom-links">
                <a style={{color:"black"}}  href="#terms">Terms and conditions</a> | <a style={{color:"black"}}  href="#privacy">Privacy Policy</a>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;